onePulse.controller('NewPulseController', ['PulseService',
    function (PulseService) {

        var document = new Document();
        PulseService.createPulse(document.createEvent('Event'));

    }]);